"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.detachCovenantLoanTapeArtifacts = exports.createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies = exports.attachCovenantLoanTapeArtifactToMasterLoanTape = void 0;
const lodash = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const { cloneDeep } = lodash;
// Matches the loan tape feeding a generatedCovenantLoanTape. master and
// preassignedMaster have one generated tape per loanProductSlug; preassigned
// may have several, so it must also match the creditFacilitySlug.
const loanTapeFilter = ({ loanTapeType, loanProductSlug, creditFacilitySlug, missingFacilityMessage, }) => {
    switch (loanTapeType) {
        case 'masterLoanTape':
        case 'preassignedMasterLoanTape':
            return (loanTape) => loanTape.loanProductSlug === loanProductSlug;
        case 'preassignedLoanTape':
            (0, common_1.finleyAssert)(creditFacilitySlug, missingFacilityMessage);
            return (loanTape) => loanTape.creditFacilitySlug === creditFacilitySlug &&
                loanTape.loanProductSlug === loanProductSlug;
        default:
            return (0, common_1.finleyAssertUnreachable)(loanTapeType);
    }
};
/**
 * Revises dependencies between generatedCovenantLoanTape and input
 * generatedLoanTape artifact.
 *
 *                        *** Current ***
 * +---------------------+      +---------------------------+
 * | generatedLoanTape   | ---> | generatedCovenantLoanTape |
 * +---------------------+      +---------------------------+
 *
 *                        *** Revised ***
 * +---------------------+      +------------------+      +---------------------------+
 * | generatedLoanTape   | ---> |  masterLoanTape  | ---> | generatedCovenantLoanTape |
 * +---------------------+      +------------------+      +---------------------------+
 *
 * masterLoanTape is needed to ensure access to all receivables
 *
 * output of generatedCovenantLoanTape is optionally borrowingBaseReport, which
 * is not affected by synthetic actions
 */
const attachCovenantLoanTapeArtifactToMasterLoanTape = ({ dbGraph, loanTapeTypeMap, }) => {
    // find instances of generatedCovenantLoanTape to use as the basis of this
    // synthetic mutation, otherwise return early since there is nothing to update
    const covenantLoanTapesInGraph = utils.filterGeneratedCovenantLoanTapes({
        dataTapes: dbGraph.dataTapes,
    });
    if (covenantLoanTapesInGraph.length === 0) {
        return dbGraph;
    }
    const clonedDbGraph = cloneDeep(dbGraph);
    const { dataTapes } = clonedDbGraph;
    let { dataTapeDependencies } = clonedDbGraph;
    for (const covenantLoanTape of covenantLoanTapesInGraph) {
        const { creditFacilitySlug, loanProductSlug } = covenantLoanTape;
        (0, common_1.finleyAssert)(loanProductSlug, 'loanProductSlug must exist on generatedCovenantLoanTape');
        const loanTapeType = loanTapeTypeMap[loanProductSlug];
        const masterLoanTapes = utils.filterMasterLoanTapes({ dataTapes });
        const filteredMasterLoanTapes = masterLoanTapes.filter(loanTapeFilter({
            loanTapeType,
            loanProductSlug,
            creditFacilitySlug,
            missingFacilityMessage: 'creditFacilitySlug must exist on generatedCovenantLoanTape with [loanTapeType:preassignedLoanTape]',
        }));
        (0, common_1.finleyAssert)(filteredMasterLoanTapes.length === 1, `unable to find single masterLoanTape with [creditFaciltySlug:${creditFacilitySlug}] and [loanProductSlug:${loanProductSlug}, found: ${filteredMasterLoanTapes.length}`);
        const masterLoanTape = filteredMasterLoanTapes[0];
        const covenantLoanTapeDependencies = utils.getDependenciesByOutputId({
            dataTapeDependencies,
            outputArtifactId: covenantLoanTape.id,
        });
        (0, common_1.finleyAssert)(covenantLoanTapeDependencies.length === 1, `covenantLoanTape should have 1 dependency, found ${covenantLoanTapeDependencies.length}`);
        const covenantLoanTapeDependency = covenantLoanTapeDependencies[0];
        // remove edge generatedLoanTape <> covenantLoanTape
        dataTapeDependencies = utils.removeDependency({
            dataTapeDependencies,
            dependencyToRemove: covenantLoanTapeDependency,
        });
        // add masterLoanTape <> covenantLoanTape edge
        dataTapeDependencies.push({
            inputArtifactId: masterLoanTape.id,
            outputArtifactId: covenantLoanTape.id,
        });
    }
    return {
        dataTapes,
        dataTapeDependencies,
    };
};
exports.attachCovenantLoanTapeArtifactToMasterLoanTape = attachCovenantLoanTapeArtifactToMasterLoanTape;
/**
 * partial logical inverse of {@link attachCovenantLoanTapeArtifactToMasterLoanTape}
 *
 * The covenant process removes the masterLoanTape -> generatedCovenantLoanTape
 * dependency and uses this helper to restore the generated-loan-tape input.
 * The master process subsequently removes the synthetic master itself.
 *
 *                        *** Current ***
 * +---------------------+      +------------------+      +---------------------------+
 * | generatedLoanTape   | ---> |  masterLoanTape  | ---> | generatedCovenantLoanTape |
 * +---------------------+      +------------------+      +---------------------------+
 *
 *                        *** Revised ***
 * +---------------------+      +---------------------------+
 * | generatedLoanTape   | ---> | generatedCovenantLoanTape |
 * +---------------------+      +---------------------------+
 *
 * output of generatedCovenantLoanTape is optionally borrowingBaseReport, which
 * is not affected by synthetic actions
 */
const createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies = ({ generatedCovenantLoanTapes, generatedLoanTapes, loanTapeTypeMap, }) => generatedCovenantLoanTapes.map((covenantLoanTape) => {
    const { creditFacilitySlug, loanProductSlug } = covenantLoanTape;
    (0, common_1.finleyAssert)(loanProductSlug, 'loanProductSlug must exist on generatedCovenantLoanTape');
    const loanTapeType = loanTapeTypeMap[loanProductSlug];
    const filteredGeneratedLoanTapes = generatedLoanTapes.filter(loanTapeFilter({
        loanTapeType,
        loanProductSlug,
        creditFacilitySlug,
        missingFacilityMessage: 'creditFacilitySlug must exist on generatedCovenantLoanTape for [loanTapeType:preassignedLoanTape]',
    }));
    (0, common_1.finleyAssert)(filteredGeneratedLoanTapes.length === 1, `unable to find single generatedLoanTape with [creditFaciltySlug:${creditFacilitySlug}] and [loanProductSlug:${loanProductSlug}], found: ${filteredGeneratedLoanTapes.length}`);
    const generatedLoanTape = filteredGeneratedLoanTapes[0];
    return {
        inputArtifactId: generatedLoanTape.id,
        outputArtifactId: covenantLoanTape.id,
    };
});
exports.createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies = createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies;
const detachCovenantLoanTapeArtifacts = (graph, { loanTapeTypeMap }) => {
    const generatedCovenantLoanTapes = utils.filterGeneratedCovenantLoanTapes(graph);
    const covenantIds = new Set(generatedCovenantLoanTapes.map((tape) => tape.id));
    const loanIds = new Set([
        ...utils.filterGeneratedLoanTapes(graph),
        ...utils.filterMasterLoanTapes(graph),
    ].map((tape) => tape.id));
    return {
        dataTapes: graph.dataTapes,
        dataTapeDependencies: [
            ...graph.dataTapeDependencies.filter((edge) => !loanIds.has(edge.inputArtifactId) ||
                !covenantIds.has(edge.outputArtifactId)),
            ...(0, exports.createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies)({
                generatedCovenantLoanTapes,
                generatedLoanTapes: utils.filterGeneratedLoanTapes(graph),
                loanTapeTypeMap,
            }),
        ],
    };
};
exports.detachCovenantLoanTapeArtifacts = detachCovenantLoanTapeArtifacts;
exports.syntheticProcess = {
    toDb: (dbGraph, { loanTapeTypeMap }) => (0, exports.attachCovenantLoanTapeArtifactToMasterLoanTape)({
        dbGraph,
        loanTapeTypeMap,
    }),
    fromDb: exports.detachCovenantLoanTapeArtifacts,
};
//# sourceMappingURL=covenantLoanTape.js.map